import React from 'react'
import Footer from '../Footer/Footer'
import Navbar from '../Navbar/Navbar'

const AppLayout = ({children}) => {
  return (
    <>   
        <Navbar/>
        <main className='relative'>{children}</main>
        <Footer/>
    </>
  )
}

export default AppLayout
